module.exports = __webpack_public_path__ + "static/media/ar_white.0ba7b043.png";